import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as globals from '@reusable/services/globals';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CarProvidersAuthService {
  jwtHelper: JwtHelperService = new JwtHelperService();
  responseData: any;
  public loggedIn = new BehaviorSubject<boolean>(this.tokenAvailable());
  userProfileData: any;

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(
    private httpClient: HttpClient,
    private gtn: globals.GetTokenNow,
    private router: Router
  ) { }
  changeLoginState(state: any) {
    this.loggedIn.next(state);
  }

  private tokenAvailable(): boolean {
    return !!localStorage.getItem('accessToken');
  }

  public getToken(): string {
    return localStorage.getItem('accessToken');
  }
  public getDecodedToken(): any {
    const token = this.getToken();
    return this.jwtHelper.decodeToken(token);
  }

  public isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    const { roles } = this.jwtHelper.decodeToken(token);
    if (roles.indexOf('services-seller') < 0 && roles.indexOf('services-staff') < 0) {
      return false;
    }
    if (this.jwtHelper.isTokenExpired(token)) {
      return false;
    }

    return true;
  }
  private setToken(token) {
    localStorage.setItem('accessToken', token.accessToken);
    localStorage.setItem('refreshToken', token.refreshToken);
  }

  logout() {
    this.loggedIn.next(false);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }
  doLogin(body) {
    return this.httpClient.post(`${globals.domain}/services-provider/login/`, JSON.stringify(body), this.gtn.optionsProvider())
      .pipe(
        map(res => res as any)
      );
  }
  getUserProfile() {
    return this.httpClient.get(`${globals.domain}/car-services-branch/profile/view`, this.gtn.optionsProvider())
      .pipe(
        map(res => res as any)
      );
  }
}